import { cx } from '@linaria/core';
import { useId } from 'react';
import { useOpgavekompleksetComponent } from '../../../state/context.data.js';
import { AudioMedia } from '../../molecule.media/audio.js';
import { ImageMedia } from '../../molecule.media/image.js';
import { LinkMedia } from '../../molecule.media/link.js';
import { TextMedia } from '../../molecule.media/text.js';
import { VideoMedia } from '../../molecule.media/video.js';
import { taskSelectors } from '../_task.selectors.js';
import { media, wrapper } from './_introduction.style.js';
import { jsx } from 'react/jsx-runtime';

function TaskIntroduction(props) {
  const id = useId();
  const component = useOpgavekompleksetComponent();
  const lastTextNodeIndex = props.introduction.findLastIndex(it => it.type === "Text");
  const content = props.introduction.map((node, index) => {
    switch (node.type) {
      case "Text":
        return /*#__PURE__*/jsx(TextMedia, {
          avoidBreakAfter: index === 0 && props.introduction.length > 1,
          node: node,
          introductionId: id,
          withReadOutLoudButton: lastTextNodeIndex === index
        }, index);
      case "Image":
        return /*#__PURE__*/jsx(ImageMedia, {
          node: node,
          sizes: "700px"
        }, index);
      case "Video":
        return /*#__PURE__*/jsx(VideoMedia, {
          node: node
        }, index);
      case "Audio":
        return /*#__PURE__*/jsx(AudioMedia, {
          node: node
        }, index);
      case "Link":
        return /*#__PURE__*/jsx(LinkMedia, {
          node: node
        }, index);
    }
  });
  if (props.introduction.length === 0) {
    return null;
  }
  return /*#__PURE__*/jsx("div", {
    className: cx(wrapper, taskSelectors.introduction.className),
    "data-audience": component.data.settings.standalone.audience,
    "data-stacked": typeof props.indexInStack === "number",
    children: /*#__PURE__*/jsx("div", {
      id: id,
      className: media,
      "data-reapply-font-scales": true,
      children: content
    })
  });
}

export { TaskIntroduction };
//# sourceMappingURL=_introduction.js.map
